import React, { FC } from 'react'
import * as UI from './ButtonWithIconStyled'

type TProps = {
  text: string
  icon?: string
  color?: string
  colorDark?: string
  fontColor?: string
  className?: string
  disabled?: boolean
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const ButtonWithIcon: FC<TProps> = ({
  icon,
  text,
  color = '#c0392b',
  colorDark = '#a53125',
  fontColor = '#fff',
  children,
  className = '',
  disabled = false,
  ...rest
}) => {
  return (
    <UI.ButtonWithIcon
      color={color}
      colorDark={colorDark}
      fontColor={fontColor}
      className={`button ${className}`}
      disabled={disabled}
      {...rest}
    >
      <span>{text}</span>
      <div className="icon">
        {icon && <i className={`fas fa-${icon}`}></i>}
        {children}
      </div>
    </UI.ButtonWithIcon>
  )
}

export { ButtonWithIcon }
